import { render, staticRenderFns } from "./ListDepense.vue?vue&type=template&id=54143267"
import script from "./ListDepense.vue?vue&type=script&lang=js"
export * from "./ListDepense.vue?vue&type=script&lang=js"
import style0 from "./ListDepense.vue?vue&type=style&index=0&id=54143267&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports